import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";

//UI
import { Button, Modal, Table, Loader, Breadcrumb, Divider, Message } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import HeaderCatalog from "../../../components/headerCatalog";

// Resources
import { scrollToTop } from "../../resources/utils";
import { fetchFlight } from "../../../redux/actions/catalogs/flight/fetchFlight";
import { fetchFlightRoutes, initialStateFlightRoutes, deleteRoute } from "../../../redux/slices/custom/catalogs/flightRoutes/flightRoutes.slice";

export default function FlightRouteList() {
  const { t } = useTranslation();
  let { flight_id } = useParams();
  const flightState = useSelector((state) => state.flightReducer);
  const { fetching, routes, message, error } = useSelector((state) => state.flightRoute);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchFlight(flight_id));
    dispatch(fetchFlightRoutes(flight_id));
    scrollToTop();
    return () => {
      dispatch(initialStateFlightRoutes());
    };
  }, [dispatch, flight_id]);

  if (flightState.fetching || fetching ) {
    return <Loader active inline />;
  }

  if (message === "resource deleted successfully") {
    dispatch(fetchFlightRoutes(flight_id));
  }

  const handleDelete = (id) => {
    dispatch(deleteRoute(id));
  };

  return (
    <>
      {error ? (
        <Message negative content={t(error)} />
      ) : (
        ""
      )}
      <Breadcrumb>
        <Breadcrumb.Section >
          <Link to="/flights" className="section">{t("flight_title")}</Link>
        </Breadcrumb.Section>
        <Breadcrumb.Divider />
        <Breadcrumb.Section active>{flightState.flight.code}</Breadcrumb.Section>
      </Breadcrumb>
      <Divider variant="fullWidth" />

      <HeaderCatalog title={t("route_title")} message={flightState.message} to={`/flight/${flight_id}/new_route`} />
      <Table color="blue" striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>{t("flight_origin")}</Table.HeaderCell>
            <Table.HeaderCell>{t("flight_destination")}</Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {routes.map((route) => (
            <Table.Row key={route.id}>
              <Table.Cell >{route.origin_city}</Table.Cell>
              <Table.Cell >{route.destination_city}</Table.Cell>
              <Table.Cell collapsing>
                <Modal
                  trigger={
                    <Button circular color='red' icon='trash alternate' />
                  }
                  content={t("route_delete")}
                  actions={[
                    t("canceled_button"),
                    {
                      key: "eliminar",
                      content: t("delete_button"),
                      className: "delete_button icon_color",
                      onClick: () => handleDelete(route.id),
                    },
                  ]}
                  size="tiny"
                />
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  );
}
